export const getVersion = () => {
  const appVersion = process.env.REACT_APP_VERSION;
  const appBuild = process.env.REACT_APP_BUILD;
  const appEnv = process.env.REACT_APP_ENV !== 'production' && process.env.REACT_APP_ENV;
  const version = [appVersion, appBuild, appEnv].filter(Boolean).join(' - ');

  return version;
};
